export function initDarkMode() {
  var darkIcon = document.getElementById("theme-toggle-dark-icon");
  var lightIcon = document.getElementById("theme-toggle-light-icon");
  var btn = document.getElementById("theme-toggle");

  if (!darkIcon || !lightIcon || !btn) return;

  if (btn._darkModeInit) return;
  btn._darkModeInit = true;

  if (
    localStorage.getItem("color-theme") === "dark" ||
    (!("color-theme" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches)
  ) {
    lightIcon.classList.remove("hidden");
    darkIcon.classList.add("hidden");
  } else {
    darkIcon.classList.remove("hidden");
    lightIcon.classList.add("hidden");
  }

  btn.addEventListener("click", function () {
    darkIcon.classList.toggle("hidden");
    lightIcon.classList.toggle("hidden");

    if (localStorage.getItem("color-theme")) {
      if (localStorage.getItem("color-theme") === "light") {
        document.documentElement.classList.add("dark");
        localStorage.setItem("color-theme", "dark");
      } else {
        document.documentElement.classList.remove("dark");
        localStorage.setItem("color-theme", "light");
      }
    } else {
      if (document.documentElement.classList.contains("dark")) {
        document.documentElement.classList.remove("dark");
        localStorage.setItem("color-theme", "light");
      } else {
        document.documentElement.classList.add("dark");
        localStorage.setItem("color-theme", "dark");
      }
    }

    document.dispatchEvent(new Event("rerender-charts"));
  });
}
